import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { NgSelectModule } from '@ng-select/ng-select';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { TimeagoModule } from "ngx-timeago";
// import { MySocketWrapper } from './services/socket-service/socket-wrapper';
// import { SocketService } from './services/socket-service/socket-service.service';
import { DatePipe } from './pipes/date-pipe/date.pipe';
import { SideNavComponent } from './components/shared/layout/side-nav/side-nav.component';
import { HeaderComponent } from './components/shared/layout/header/header.component';
import { OWL_DATE_TIME_FORMATS, OwlDateTimeModule } from '@danielmoncada/angular-datetime-picker';
import { ToastrModule } from 'ngx-toastr';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { SigninComponent } from './components/auth/signin/signin.component';
import { ResetPasswordComponent } from './components/auth/reset-password/reset-password.component';
import { TokenInterceptor } from './services/app/token-interceptor/token.interceptor';
import { SortByPipe } from './pipes/order-by/order-by.pipe';
import { CamelCasePipe } from './pipes/camelcase.filter/camelcase.filter.pipe';
import { GoogleMapsModule } from '@angular/google-maps';
import { NgxUiLoaderConfig, NgxUiLoaderHttpModule, NgxUiLoaderModule } from 'ngx-ui-loader';
import { ClockTimePipe } from './pipes/clock-time/clock-time.pipe';
import { FilterPipe } from './pipes/list-filter-pipe/list-filter-pipe';
import { CircleTimerModule } from "./libraries/circle-timer/src/lib/circle-timer.module";
import { MySocketWrapper } from './services/app/socket-service/socket-wrapper';
import { SocketService } from './services/app/socket-service/socket-service.service';
import { CommonModule } from '@angular/common';
import { NgxPaginationModule } from 'ngx-pagination';
import { GooglePlaceDirective } from './directives/google-places-directive/google-place.directive';
import { ProfileComponent } from './components/profile/profile.component';
import { NotificationModalComponent } from './components/slideouts/notification-modal/notification-modal.component';
import { NotificationsComponent } from './components/shared/layout/notifications/notifications.component';
import { AddMemberComponent } from './components/distributions/members/add-member/add-member.component';
import { CreateTripComponent } from './components/distributions/trip-intake/create-trip/create-trip.component';
import { TripListComponent } from './components/distributions/trips/trip-list/trip-list.component';
import { MemberListComponent } from './components/distributions/members/member-list/member-list.component';
import { FileParsingComponent } from './components/distributions/trip-intake/file-parsing/file-parsing/file-parsing.component';
import { TripDetailModalComponent } from './components/slideouts/distributions/trip-detail-modal/trip-detail-modal.component';
import { StandingOrderListComponent } from './components/distributions/trip-intake/standing-order/standing-order-list/standing-order-list.component';
import { StandingorderDetailModalComponent } from './components/slideouts/standingorder-detail-modal/standingorder-detail-modal.component';
import { TripsDistributionModalComponent } from './components/slideouts/distributions/trips-distribution-modal/trips-distribution-modal.component';
import { TripMonitoringComponent } from './components/distributions/trips/trip-monitoring/trip-monitoring.component';
import { MemberWrapperComponent } from './components/distributions/members/member-wrapper/member-wrapper.component';
import { CancelModalComponent } from './components/slideouts/cancel-modal/cancel-modal.component';
import { NotesModalComponent } from './components/slideouts/notes/notes-modal/notes-modal.component';
import { BillingListComponent } from './components/billing/billing-list/billing-list.component';
import { ManualPaymentModalComponent } from './components/slideouts/manual-payment-modal/manual-payment-modal.component';
import { TripCardComponent } from './components/shared/layout/trips/trip-card/trip-card.component';
import { MultiCancelModalComponent } from './components/slideouts/multi-cancel-modal/multi-cancel-modal.component';
import { TripActionDropdownComponent } from './components/shared/dropdowns/trip-action-dropdown/trip-action-dropdown.component';
import { OutsideClickDirective } from './directives/outside-click-directive/outside-click.directive';
import { TrimInputDirective } from './directives/trim-input-directive/trim-input.directive';
import { MemberTripsModalComponent } from './components/slideouts/member-trips-modal/member-trips-modal.component';
import { TripListingComponent } from './components/shared/layout/trips/trip-listing/trip-listing.component';
import { MemberDetailModalComponent } from './components/slideouts/member-detail-modal/member-detail-modal.component';
import { OWL_MOMENT_DATE_TIME_ADAPTER_OPTIONS, OwlMomentDateTimeModule } from '@danielmoncada/angular-datetime-picker-moment-adapter';
import { GoogleMapsInitializerService } from './services/app/googlemap-key-service/google-maps-initializer.service';
import { CalculateFareModalComponent } from './components/slideouts/calculate-fare-modal/calculate-fare-modal.component';
import { StandingOrderTripWrapperComponent } from './components/distributions/trip-intake/standing-order/standing-order-trip-wrapper/standing-order-trip-wrapper.component';
import { ConvertPhoneNumberDirective } from './directives/number-directive/convert-phone-number.directive';
import { TripsTrailsModalComponent } from './components/slideouts/trips-trails-modal/trips-trails-modal.component';
import { DobFormatterPipe } from './pipes/dob-formatter/dob-formatter.pipe';
import { PendingCancelModalComponent } from './components/slideouts/pending-cancel-modal/pending-cancel-modal.component';
import { ForgotPasswordComponent } from './components/auth/forgot-password/forgot-password/forgot-password.component';
import { ToolTipDirective } from './directives/tooltip-directive/tool-tip.directive';
import { CopyToClipboardDirective } from './directives/clipboard-directive/copy-to-clipboard.directive';
import { PaymentsListComponent } from './components/payments/payments-list/payments-list.component';
import { TransactionsListComponent } from './components/payments/transactions-list/transactions-list.component';
import { TutorialsListComponent } from './components/tutorials/tutorials-list/tutorials-list.component';
import { PaymentCardModalComponent } from './components/slideouts/payment-card-modal/payment-card-modal.component';
import { StatisticsComponent } from './components/statistics/statistics.component';
import { SupportTicketsComponent } from './components/support/support-tickets/support-tickets.component';
import { SupportChatComponent } from './components/support/support-chat/support-chat.component';
import { ChatThreadComponent } from './components/support/chat-thread/chat-thread.component';
import { TicketDetailComponent } from './components/support/ticket-detail/ticket-detail.component';
import { AddSupportTicketComponent } from './components/support/add-support-ticket/add-support-ticket.component';
import { SupportContactPickerComponent } from './components/support/support-contact-picker/support-contact-picker.component';
import { SupportReferenceDetailComponent } from './components/support/support-reference-detail/support-reference-detail.component';


export const MY_MOMENT_FORMATS = {
  fullPickerInput: 'MM/DD/YYYY HHmm',
  parseInput: 'l LT',
  datePickerInput: 'l',
  timePickerInput: 'HH:mm',
  monthYearLabel: 'MMM YYYY',
  dateA11yLabel: 'LL',
  monthYearA11yLabel: 'MMMM YYYY',
};
const ngxUiLoaderConfig: NgxUiLoaderConfig = {
  bgsColor: 'red',
  bgsOpacity: 0.5,
  bgsPosition: 'bottom-right',
  bgsSize: 80,
  bgsType: 'ball-spin-clockwise',
  blur: 0,
  fgsColor: '#727cf5',
  fgsPosition: 'center-center',
  fgsSize: 0,
  fgsType: 'ball-spin',
  gap: 24,
  logoPosition: 'center-center',
  logoSize: 150,
  logoUrl: '',
  masterLoaderId: 'master',
  overlayBorderRadius: '0',
  overlayColor: '#ffffff00',
  pbColor: '#727cf5',
  pbDirection: 'ltr',
  pbThickness: 3,
  hasProgressBar: true,
  text: '',
  textColor: '#FFFFFF',
  textPosition: 'center-center',
};

@NgModule({
  declarations: [
    AppComponent,
    DashboardComponent,
    SideNavComponent,
    HeaderComponent,
    SigninComponent,
    ResetPasswordComponent,
    SortByPipe,
    CamelCasePipe,
    ClockTimePipe,
    FilterPipe,
    DatePipe,
    GooglePlaceDirective,
    ProfileComponent,
    NotificationModalComponent,
    NotificationsComponent,
    AddMemberComponent,
    CreateTripComponent,
    TripListComponent,
    MemberListComponent,
    FileParsingComponent,
    TripDetailModalComponent,
    StandingOrderListComponent,
    TripsDistributionModalComponent,
    TripMonitoringComponent,
    StandingorderDetailModalComponent,
    TripsDistributionModalComponent,
    MemberWrapperComponent,
    StandingOrderTripWrapperComponent,
    CancelModalComponent,
    MultiCancelModalComponent,
    CancelModalComponent,
    TripCardComponent,
    NotesModalComponent,
    BillingListComponent,
    ManualPaymentModalComponent,
    TripActionDropdownComponent,
    OutsideClickDirective,
    TrimInputDirective,
    MemberTripsModalComponent,
    TripListingComponent,
    MemberDetailModalComponent,
    CalculateFareModalComponent,
    ConvertPhoneNumberDirective,
    TripsTrailsModalComponent,
    DobFormatterPipe,
    PendingCancelModalComponent,
    ForgotPasswordComponent,
    ToolTipDirective,
    CopyToClipboardDirective,
    PaymentsListComponent,
    TransactionsListComponent,
    TutorialsListComponent,
    PaymentCardModalComponent,
    StatisticsComponent,
    SupportTicketsComponent,
    SupportChatComponent,
    ChatThreadComponent,
    TicketDetailComponent,
    AddSupportTicketComponent,
    SupportContactPickerComponent,
    SupportReferenceDetailComponent,
  ],
  imports: [
    BrowserModule,
    FormsModule,
    NgSelectModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    HttpClientModule,
    NgxPaginationModule,
    TimeagoModule.forRoot(),
    NgxUiLoaderModule.forRoot(ngxUiLoaderConfig), // import NgxUiLoaderModule
    NgxUiLoaderHttpModule.forRoot({
      exclude: [
      ],
      excludeRegexp: [
        'notifications/unread-count',
        // support chat requests run in the background while the user is chatting
        'support/chats/'
      ],
      showForeground: true
    }),
    OwlDateTimeModule,
    OwlMomentDateTimeModule,
    ToastrModule.forRoot({
        timeOut: 2000,
        maxOpened: 6,
        autoDismiss: true,
        positionClass: 'toast-bottom-left',
        // preventDuplicates: true,
        progressBar: true
    }),
    NgMultiSelectDropDownModule.forRoot(),
    GoogleMapsModule,
    NgSelectModule,
    CircleTimerModule,
    CommonModule

],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: (initializer: GoogleMapsInitializerService) => () => initializer.initialize(),
      deps: [GoogleMapsInitializerService],
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true
    },
    { provide: OWL_DATE_TIME_FORMATS, useValue: MY_MOMENT_FORMATS },
    { provide: OWL_MOMENT_DATE_TIME_ADAPTER_OPTIONS, useValue: { useUtc: false } },
    DatePipe,
    MySocketWrapper,
    SocketService

  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



